/** Round a currency value to 2 decimal places to avoid IEEE 754 floating-point drift. */
export function roundCurrency(value: number): number {
  const rounded = Math.round((value + Number.EPSILON) * 100) / 100
  return rounded === 0 ? 0 : rounded // normalize -0 to 0
}
